/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookDto from './BookDto';
import PaginationModel from './PaginationModel';

/**
 * The SearchingQueryResponseModelBookDto model module.
 * @module model/SearchingQueryResponseModelBookDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelBookDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelBookDto</code>.
     * @alias module:model/SearchingQueryResponseModelBookDto
     */
    constructor() { 
        
        SearchingQueryResponseModelBookDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelBookDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelBookDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelBookDto} The populated <code>SearchingQueryResponseModelBookDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelBookDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [BookDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelBookDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/BookDto>} result
 */
SearchingQueryResponseModelBookDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelBookDto;

